import React from 'react';
import { Button, Typography } from 'antd';
import { CloseOutlined, EnterOutlined } from '@ant-design/icons';
import { Message } from '../../types/chat';
import { getMessageContent, parseRichMessage } from './utils';
import '../styles/ReplyField.css';

const { Text } = Typography;

interface ReplyFieldProps {
  replyToMessage: Message;
  onCancel: () => void;
}

const ReplyField: React.FC<ReplyFieldProps> = ({ replyToMessage, onCancel }) => {
  // Truncate message content if it's too long
  const truncateContent = (content: string, maxLength: number = 50) => {
    if (content.length <= maxLength) return content;
    return content.substring(0, maxLength) + '...';
  };

  const messageContent = getMessageContent(replyToMessage);
  const richMessage = parseRichMessage(messageContent);
  let truncatedContent = truncateContent(messageContent);
  if (richMessage) {
    truncatedContent = truncateContent(richMessage.messageContent);
  }

  return (
    <div className="reply-field">
      <div className="reply-field-content">
        <div className="reply-field-indicator">
          <EnterOutlined />
        </div>
        <div className="reply-field-info">
          <Text strong className="reply-field-sender">
            {richMessage ? richMessage.username : replyToMessage.sender}
          </Text>
          <Text className="reply-field-text">
            {truncatedContent}
          </Text>
        </div>
      </div>
      <Button
        type="text"
        size="small"
        icon={<CloseOutlined />}
        onClick={onCancel}
        className="reply-field-close"
      />
    </div>
  );
};

export default ReplyField; 